import { Command } from 'commander';
import { confirm } from '@inquirer/prompts';
import { ComponentsService } from '../services/components.service.js';

export function createClearBackupsCommand(): Command {
    return new Command('clear-backups')
        .description('Clear backup files')
        .option('-y, --yes', 'Skip confirmation')
        .action(async (options) => {
            const service = new ComponentsService();
            const backups = await service.listBackups(process.cwd());

            if (backups.length === 0) {
                console.log('No backups found.');
                return;
            }

            console.log(`Found ${backups.length} backup(s):`);
            if (backups.length <= 5) {
                backups.forEach(b => console.log(` - ${b}`));
            } else {
                backups.slice(0, 5).forEach(b => console.log(` - ${b}`));
                console.log(`   ...and ${backups.length - 5} more`);
            }
            console.log();

            if (!options.yes) {
                const ok = await confirm({ message: 'Delete all backups?', default: false });
                if (!ok) return;
            }

            await service.clearBackups(process.cwd());
            console.log('✅ Backups cleared.');
        });
}
